import React from 'react';
import { string, number } from 'prop-types';
import { currencyToSign } from '../../utils/utils';

const propTypes = {
  title: string,
  colSpan: number,
  currency: string,
};
const defaultProps = {
  title: '',
  colSpan: 1,
  currency: 'RUB',
};

const getSuffix = (title, currency) => {
  switch (title) {
    case 'Финансы':
    case 'Finance':
      return `${title}, ${currencyToSign(currency)}`;
    default:
      return title;
  }
};

const StatisticsTableGroup = ({ title, colSpan, currency }) => (
  <th colSpan={colSpan}>{title.match(/_EMPTY_/) ? '' : getSuffix(title, currency)}</th>
);

StatisticsTableGroup.propTypes = propTypes;
StatisticsTableGroup.defaultProps = defaultProps;

export default StatisticsTableGroup;
